import { render, staticRenderFns } from "./healthCheckWidget.vue?vue&type=template&id=35329cc0&"
import script from "./healthCheckWidget.vue?vue&type=script&lang=js&"
export * from "./healthCheckWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerAudio from 'quasar/src/components/spinner/QSpinnerAudio.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip,QBtn,QSpinnerAudio});
